import { React } from 'react';
import styled from 'styled-components';
import ClassManageView from '../../Model/Individual/ClassManageModel/ClassManageView';

function ClassManagePage() {

  return (
    <Container>
      <ClassManageView/>
    </Container>
  )
}

export default ClassManagePage;

const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;